export default "__VITE_ASSET__CcLqLX3d__"